<template>
  <div>
    <div class="fixed-foot">
      <!-- <div class="btn" @click="onScon">扫一扫</div> -->
    </div>
  </div>
</template>

<script>
import WxMixin from '@/mixins/wx'
export default {
  mixins: [WxMixin],
  data () {
    return {
      count: 0
    }
  },
  methods: {
    onScon () {
      let vm = this
      // console.log(needResult, scope)
      wx.scanQRCode({
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          // console.log('scanQRCode success', res)
          // if (needResult && res && res.resultStr) {
          //   let result = res.resultStr
          //   let qrcode = result.substring(result.length - 10, result.length)
          //   console.log('qrcode', qrcode)
          //   window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_WECHAT_APP_ID}&redirect_uri=${process.env.VUE_APP_AUTHORIZE}${qrcode}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`
          // } else {
          vm.closeWindowWX()
          // }
        },
        fail: (err) => {
          console.log('scanQRCode fail', err)
          vm.closeWindowWX()
        }
      })
    },
    closeWindowWX () {
      this.count++
      wx.closeWindow()
      if (WeixinJSBridge) {
        WeixinJSBridge.call('closeWindow')
      }
      if (this.count < 50) {
        setTimeout(() => {
          this.closeWindowWX()
        }, 100)
      }
    }
  },
  created () {
    this.loadWXScript(['scanQRCode'], () => {
      this.onScon()
    })
  }
}
</script>

<style lang="less">
.fixed-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 28px 28px 50px;
  .btn {
    margin-top: 20px;
  }
}
</style>
